<script lang="ts">
  import { KeyboardArrowDown } from '@athena-lib/Icons';
  import clsx from 'clsx';
  import { useDropdown } from './useDropdown.svelte';
  import { onClickOutside } from './onClickOutside.svelte';
  import type { ProductWizardDropdownProps } from './types';

  const props: ProductWizardDropdownProps = $props();
  let { isOpen, selected, toggleOpen, triggerId, menuId } = useDropdown(props);
</script>

<div class={clsx(props.class, 'relative flex flex-col gap-2')}>
  <button
    id={triggerId()}
    type="button"
    class="flex w-full justify-between rounded-lg border border-st-gray-200 px-4 py-4"
    onclick={() => toggleOpen(!isOpen())}
    role="combobox"
    aria-haspopup="listbox"
    aria-controls={menuId()}
    aria-expanded={isOpen()}
    aria-labelledby={props.labelledBy}
  >
    <span>{selected()?.label ?? props.placeholder}</span>
    <span><KeyboardArrowDown sizeClass="h-5 w-5" /></span>
  </button>
  <ul
    class:hidden={!isOpen()}
    role="listbox"
    id={menuId()}
    class="absolute top-full z-10 grid w-full cursor-pointer auto-rows-fr rounded-lg border border-st-gray-200 bg-white"
    use:onClickOutside={() => toggleOpen(false, false)}
  >
    {@render props.children?.()}
  </ul>
</div>
